module.exports = __webpack_public_path__ + "static/feature-3-35628ac5ee5335ae64a92f58f34fcfe6.svg";